import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { FallbackImageCompany, FallbackImageGroups, FallbackImageTopic, FallbackImageUserFemale, FallbackImageUserMale, FallbackImageUserNeutral, } from '@xingternal/illustrations';
export const getFallbackImage = (type) => {
    switch (type) {
        case 'company':
            return _jsx(FallbackImageCompany, {});
        case 'groups':
            return _jsx(FallbackImageGroups, {});
        case 'topic':
            return _jsx(FallbackImageTopic, {});
        case 'female-user':
            return _jsx(FallbackImageUserFemale, {});
        case 'male-user':
            return _jsx(FallbackImageUserMale, {});
        case 'neutral-user':
            return _jsx(FallbackImageUserNeutral, {});
        default:
            return _jsx(FallbackImageUserNeutral, {});
    }
};
export const FallbackImage = ({ type, ...props }) => {
    const renderFallbackImage = (type) => {
        switch (type) {
            case 'company':
                return _jsx(FallbackImageCompany, { ...props });
            case 'groups':
                return _jsx(FallbackImageGroups, { ...props });
            case 'topic':
                return _jsx(FallbackImageTopic, { ...props });
            case 'female-user':
                return _jsx(FallbackImageUserFemale, { ...props });
            case 'male-user':
                return _jsx(FallbackImageUserMale, { ...props });
            case 'neutral-user':
                return _jsx(FallbackImageUserNeutral, { ...props });
            default:
                return _jsx(FallbackImageUserNeutral, { ...props });
        }
    };
    return _jsx(React.Fragment, { children: renderFallbackImage(type) });
};
//# sourceMappingURL=get-fallback-image.js.map